import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { environment } from '../../../../environments/environment';
import { TranslateService } from "@ngx-translate/core";
import { CustomerService } from "../../services/customer.service";
import { FileUploadConstants } from "../../constants/file-upload.constants";
import { ReportService } from "../../services/report.service";
import { CommonService } from "../../../shared/services/common.service";
import { NotificationType } from "../../enums/notification-types.enum";
import { DeliveryPreference, MemberLevel, OrderTypeTitle, } from '../../common/enumerations';
import { OrderTypeValues, DelivaryOptionType } from '../../common/constants';
import { MemberTypeEnum } from "../../enums/member-type.enum";
import { StatusConstants } from "../../constants/status.constants";
import { DatePipe } from "@angular/common";
import { DateConstants } from "../../constants/date.constants";
import { DistributorIdFormatPipe } from "../../../common/pipes/distributor-id-format.pipe";
import { StoreConfig } from "../../../shared/interface/StoreConfig.interface";
import { CurrencyTransformPipe } from "../../../common/pipes/currency-format.pipe";
import { ResponseStatus } from "../../constants/response-status-constants";



@Component({
    selector: 'app-order-reports',
    templateUrl: '../../templates/template1/views/reports/order-reports.component.html',
    styleUrls: [
        '../../templates/template1/themes/default/less/order-reports.less'
    ],
    providers: [DistributorIdFormatPipe, CurrencyTransformPipe]
})
export class OrderReportsComponent implements OnInit {
    @Input() fromDate: string;
    @Input() toDate: string;
    @Input() storeId: [number];
    @Output() isLoadedData = new EventEmitter<boolean>();
    @Output() addFavoriteEvent = new EventEmitter<boolean>();
    @Input() storeInfo: StoreConfig;
    pageSizes = [50, 100, 150, 200];
    pageNumber: number = 1;
    pageSize: number = 50;
    pageCount: number = 0;
    currentDate = new Date();
    excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';
    printIconUrl = environment.cdnURL + '/flpi/images/print_icon.png';
    ordersReport = null;
    allOrdersReport = null;
    isResponseError = false;
    isLoading = false;
    isAllOrdersReportLoading = false;
    isShowReport = true;
    csvType = FileUploadConstants.CSV_FILE_EXTENSION;
    printType = FileUploadConstants.PRINT;
    pollCount: number = 0;
    maxPollCount = 15;

    constructor(
        private _translateService: TranslateService,
        private _customerservice: CustomerService,
        private _reportService: ReportService,
        private _commonService: CommonService,
        private _datePipe: DatePipe,
        private distributorFormatPipe: DistributorIdFormatPipe,
        private _currencyPipe: CurrencyTransformPipe
    ) { }

    ngOnInit(): void {
        // this.getOrdersReport();
        this.exportFile('csv');
    }


    /**
     * To get orders report
     * @returns void
     */
    getOrdersReport(): void {
        this.isLoading = true;
        this.getOrdersReportWithPolling(this._reportService.getConstructedOrderReportUrl(
            this.storeId,this.fromDate,this.toDate,this.pageNumber,this.pageSize,false));
    }

    getOrdersReportWithPolling(url: string) {
        this._reportService.getOrderPollReport(url).subscribe(response => {
            if (response.status === ResponseStatus.COMPLETED) {
                this.pollCount = 0;
                this.ordersReport = response.responseModel ? response.responseModel.content : null;
                this.isLoading = false;
                this.isResponseError = false;
                this.pageCount = response.responseModel ? response.responseModel.totalCount : null;
                this.isLoadedData.emit(true);
                
            }
            else if (response && response.status && response.status.code === 504) {
                const message: any = this._translateService.get('reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again');
                this._commonService.createNotification('', message.value, NotificationType.ERROR);
                this.setDefaultValues();
            } else {
                if ((response.status === ResponseStatus.IN_PROGRESS) || (response.status === ResponseStatus.QUEUED)) {
                      if (this.pollCount < this.maxPollCount) {
                        this.pollCount = this.pollCount + 1;
                        this.getOrdersReportWithPolling(response.location);
                    }
                    else{
                        const message: any = this._translateService.get('reports.Something Went Wrong, Please try again after some time');
                        this._commonService.createNotification('', message.value, NotificationType.ERROR);
                        this.setDefaultValues();
                    }
                }
            }
          },
            (error) => {
                if(error.status == 504 || (error.name && error.name.toLowerCase() == 'typeerror')){
                    const message: any = this._translateService.get('reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again');
                    this._commonService.createNotification('', message.value, NotificationType.ERROR);
                    this.setDefaultValues();
                }
                else{
                    const message: any = this._translateService.get('reports.Something Went Wrong, Please try again after some time');
                    this._commonService.createNotification('', message.value, NotificationType.ERROR);
                    this.setDefaultValues();
                }
            });
      }

    /**
     * To Set Default Values
     */
    setDefaultValues(): void {
        this.ordersReport = null;
        this.isLoading = false;
        this.isResponseError = true;
        this.pageCount = 0;
        this.isLoadedData.emit(true);
    }

    /**
     * To load orders report
     * @returns void
     */
    loadOrdersReports(): void {
        this.isShowReport = true;
        this.getOrdersReport();
    }

    /**
    * To change page size
    * @param  {number} pageSize
    * @returns void
    */
    pageSizeChange(pageSize: number): void {
        if (pageSize) {
            this.pageNumber = 1;
            this.pageSize = pageSize;
            this.getOrdersReport();
        }
    }

    /**
     * To change page number
     * @param  {number} pageNumber
     */
    pageChange(pageNumber: number) {
        this.pageNumber = pageNumber;
        this.getOrdersReport();
    }

    /**
     * To emit add favorite event to parent component
     * @returns void
     */
    addToFavorite(): void {
        this.addFavoriteEvent.emit(true);
    }

    /**
     * To Export The file
     */
    exportFile(type): void {
        // if (this.allOrdersReport && this.allOrdersReport.length > 0) {
        //     this.download(type);
        // } else {
        //     this.fetchAllOrdersReport(type);
        // }
        this.fetchAllOrdersReport(type)
    }

    /**
     * To Fetch all orders report data from service
     */
    fetchAllOrdersReport(type): void {
        this.isLoading = true;
        this.isAllOrdersReportLoading = true;
        this.getOrdersReportToExportFile(this._reportService.getConstructedOrderReportUrl(
            this.storeId,this.fromDate,this.toDate,this.pageNumber,this.pageSize,true),type);      
    }

    getOrdersReportToExportFile(url: string,type){
        this._reportService.getOrderPollReport(url).subscribe(response => {
            if (response.status === ResponseStatus.COMPLETED) {
                this.pollCount = 0;
                this.isAllOrdersReportLoading = false;
                this.isLoading = false;
                this.isResponseError = false;
                this.ordersReport = response.responseModel ? response.responseModel.content : null;
                this.allOrdersReport = response.responseModel ? response.responseModel.content : null;
                this.isLoadedData.emit(true);
                this.download(type);
            } else {
                if ((response.status === ResponseStatus.IN_PROGRESS) || (response.status === ResponseStatus.QUEUED)) {
                      if (this.pollCount < this.maxPollCount) {
                        this.pollCount = this.pollCount + 1;
                        this.getOrdersReportToExportFile(response.location,type);
                    }
                    else{
                        this.isAllOrdersReportLoading = false;
                        this.allOrdersReport = null;
                        const message: any = this._translateService.get('reports.Something Went Wrong, Please try again after some time');
                        this._commonService.createNotification('', message.value, NotificationType.ERROR);
                        this.setDefaultValues();
                    }
                }
            }
          },
            (error) => {
                const message: any = this._translateService.get('reports.Something Went Wrong, Please try again after some time');
                this._commonService.createNotification('', message.value, NotificationType.ERROR);
                this.allOrdersReport = null;
                this.isAllOrdersReportLoading = false;
            });
    }
    /**
     * To download CSV or Print file from response data
     * @param  {string} type
     * @returns void
     */
    download(type: string): void {
        const allOrdersReportLength = this.allOrdersReport && this.allOrdersReport.length ?
            this.allOrdersReport && this.allOrdersReport.length : null;
        if (allOrdersReportLength > 0) {
            const columns = [
                this._translateService.get('reports.Item Numbers')['value'],
                this._translateService.get('reports.Revision Number')['value'],
                this._translateService.get('reports.Web Order Id')['value'],
                this._translateService.get('reports.Order Number')['value'],
                this._translateService.get('reports.Payment Mode')['value'],
                this._translateService.get('reports.Payment Status')['value'],
                this._translateService.get('reports.Card Type')['value'],
                this._translateService.get('reports.Member Level')['value'],
                this._translateService.get('reports.Order Type')['value'],
                this._translateService.get('reports.Order Created Date')['value'],
                this._translateService.get('reports.Order Posted Date')['value'],
                this._translateService.get('reports.Payment Date')['value'],
                this._translateService.get('reports.Distributor ID')['value'],
                this._translateService.get('reports.Member Type')['value'],
                this._translateService.get('reports.Order Status')['value'],
                this._translateService.get('reports.AS400 Acknowledgement')['value'],
                this._translateService.get('reports.AS400 Error')['value'],
                this._translateService.get('reports.FD Status')['value'],
                this._translateService.get('reports.FD Fulfillment Number')['value'],
                this._translateService.get('reports.FD Error')['value'],
                this._translateService.get('reports.Order Total')['value'],
                this._translateService.get('reports.Source')['value'],
                this._translateService.get('reports.Shipping Method Display Name')['value'],
                this._translateService.get('reports.Payment Amount')['value'],
                this._translateService.get('reports.Order CC')['value'],
                this._translateService.get('reports.Delivery Method')['value'],
                this._translateService.get('reports.Warehouse Name')['value'],
                this._translateService.get('reports.Payment Error')['value'],
                this._translateService.get('reports.Payment Processor Transaction Number')['value'],

            ];
            const title = this._translateService.get('reports.Orders Report')['value'] + "_" + this.fromDate + this._translateService.get('reports._To_')['value'] + this.toDate;
            if (type === this.csvType) {
                this.downloadCSV(columns, allOrdersReportLength);
            } else if (type === this.printType) {
                this.printReportDetails(title, columns, allOrdersReportLength);
            }
        }
    }
    /**
    * To get the member level for  order report details
    */
    getMemberLevel(memberLevel: any): string {
        if (memberLevel === MemberLevel.RETAIL) {
            memberLevel = StatusConstants.Retail;
        }
        if (memberLevel === MemberLevel.PREFERREDCUSTOMER) {
            memberLevel = StatusConstants.PreferredCustomer;
        }
        if (memberLevel === MemberLevel.ASSISTANTSUPERVISOR) {
            memberLevel = StatusConstants.Assistant_Supervisor;
        }
        if (memberLevel === MemberLevel.SUPERVISOR) {
            memberLevel = StatusConstants.Supervisor;
        }
        if (memberLevel === MemberLevel.ASSISTANTMANAGER) {
            memberLevel = StatusConstants.Assistant_Manager;
        }
        if (memberLevel === MemberLevel.MANAGER) {
            memberLevel = StatusConstants.Manager;
        }
        if (memberLevel === MemberLevel.UNRECOGNIZEDMANAGER) {
            memberLevel = StatusConstants.Unrecognized_Manager;
        }
        if (memberLevel === MemberLevel.RECOGNIZEDMANAGER) {
            memberLevel = StatusConstants.Recognized_Manager;
        }
        if (memberLevel === MemberLevel.SENIORMANAGER) {
            memberLevel = StatusConstants.Senior_Manager;
        }
        if (memberLevel === MemberLevel.SOARINGMANAGER) {
            memberLevel = StatusConstants.Soaring_Manager;
        }
        if (memberLevel === MemberLevel.SAPPHIREMANAGER) {
            memberLevel = StatusConstants.Sapphire_Manager;
        }
        if (memberLevel === MemberLevel.DIAMONDSAPPHIREMANAGER) {
            memberLevel = StatusConstants.Diamond_Sapphire_Manager;
        }
        if (memberLevel === MemberLevel.DIAMONDMANAGER) {
            memberLevel = StatusConstants.Diamond_Manager;
        }
        if (memberLevel === MemberLevel.DOUBLEDIAMONDMANAGER) {
            memberLevel = StatusConstants.Double_Diamond_Manager;
        }
        if (memberLevel === MemberLevel.TRIPLEDIAMONDMANAGER) {
            memberLevel = StatusConstants.Triple_Diamond_Manager;
        }
        if (memberLevel === MemberLevel.DIAMONDCENTURIONMANAGER) {
            memberLevel = StatusConstants.Diamond_Centurion_Manager;
        }
        if (memberLevel === MemberLevel.GUEST) {
            memberLevel = StatusConstants.GUEST;
        }
        if (memberLevel === MemberLevel.NOVICCUSTOMER) {
            memberLevel = StatusConstants.Novus;
        }
        return memberLevel;
    }



    /**
    * To get the order type for order report details
    */
    getOrderType(orderType: any): string {
        if (orderType === OrderTypeTitle.ENROLLMENT) {
            orderType = OrderTypeValues.ENROLLMENT;
        }
        if (orderType === OrderTypeTitle.PERSONAL) {
            orderType = OrderTypeValues.PERSONAL;
        }
        if (orderType === OrderTypeTitle.AUTOSHIP) {
            orderType = OrderTypeValues.AUTOSHIP;
        }
        if (orderType === OrderTypeTitle.OFFICE_POS) {
            orderType = OrderTypeValues.OFFICE_POS;
        }
        if (orderType === OrderTypeTitle.EVENT_POS) {
            orderType = OrderTypeValues.EVENT_POS;
        }
        if (orderType === OrderTypeTitle.RETAIL) {
            orderType = OrderTypeValues.RETAIL;
        }
        if (orderType === OrderTypeTitle.AMZUS) {
            orderType = OrderTypeValues.AMZUS;
        }
        if (orderType === OrderTypeTitle.SERVICE) {
            orderType = OrderTypeValues.SERVICE;
        }
        return orderType;
    }

    /**
    * To get the member type for order report details
    */
    getMemberType(memberType: any): string {
        if (memberType === MemberTypeEnum.DISTRIBUTOR) {
            memberType = StatusConstants.Distributor;
        }
        if (memberType === MemberTypeEnum.RETAIL) {
            memberType = StatusConstants.Retail;
        }
        if (memberType === MemberTypeEnum.GUEST) {
            memberType = StatusConstants.GUEST;
        }
        if (memberType === MemberTypeEnum.FPC) {
            memberType = StatusConstants.Preferred_Customer;
        }
        return memberType;
    }

    /**
    * To get the delivery method for order report details
    */
    getDeliveryPreference(deliveryMethod: any): string {
        if (deliveryMethod === DeliveryPreference.DELIVERY) {
            deliveryMethod = DelivaryOptionType.Delivery;
        }
        if (deliveryMethod === DeliveryPreference.PICKUP) {
            deliveryMethod = DelivaryOptionType.Pickup;
        }
        if (deliveryMethod === DeliveryPreference.DROPSHIP) {
            deliveryMethod = DelivaryOptionType.Dropship;
        }
        return deliveryMethod;

    }

    /**
     * To Get Currency Value for the price
     */
    get currenyFormatValue() {
        return (value: any) => {
            if (this.storeInfo) {
                value = this._currencyPipe.getCurrencyFormat(this.storeInfo, this.storeInfo.currencyFormatCode, value);
                return value;
            }
            return value;
        };
    }


    /**
     * CSV file download functionality
     */
    downloadCSV(columns: any, allOrdersReportLength: any) {
        let rowdata = new Array<any>();
        const finalrows = new Array<any>();
        for (let i = 0; i < allOrdersReportLength; i++) {
            rowdata = [];
            const row = this.allOrdersReport[i];
            rowdata.push(row.itemNumbers ? (String.fromCharCode(39) + row.itemNumbers) : '');
            rowdata.push(row.revisionNumbers ? (String.fromCharCode(39) + row.revisionNumbers) : '');
            rowdata.push(row.webOrderId ? row.webOrderId : '');
            rowdata.push(row.orderNumber ? (String.fromCharCode(39) + row.orderNumber) : '');
            rowdata.push(row.paymentMode ? row.paymentMode : '');
            rowdata.push(row.paymentStatus ? row.paymentStatus : '');
            rowdata.push(row.cardType ? row.cardType : '');
            rowdata.push(row.memberLevelId ? this.getMemberLevel(row.memberLevelId) : '');
            rowdata.push(row.orderTypeId ? this.getOrderType(row.orderTypeId) : '');
            rowdata.push(row.orderCreatedDate ? (String.fromCharCode(39) + this._datePipe.transform(row.orderCreatedDate, DateConstants.DTFormat)) : '');
            rowdata.push(row.orderPostedDate ? (String.fromCharCode(39) + this._datePipe.transform(row.orderPostedDate, DateConstants.DTFormat)) : '');
            rowdata.push(row.paymentDate ? (String.fromCharCode(39) + this._datePipe.transform(row.paymentDate, DateConstants.DTFormat)) : '');
            const distributorId = row.distributorId ? this.distributorFormatPipe.transform(row.distributorId) : '';
            rowdata.push(distributorId);
            rowdata.push(row.memberTypeId ? this.getMemberType(row.memberTypeId) : '');
            rowdata.push(row.orderStatus ? row.orderStatus : '');
            rowdata.push(row.as400Ack ? row.as400Ack : '');
            rowdata.push(row.as400Error ? row.as400Error : '');
            rowdata.push(row.fulfillmentStatus ? row.fulfillmentStatus : '');
            rowdata.push(row.fulfillmentNumber ? (String.fromCharCode(39) + row.fulfillmentNumber) : '');
            rowdata.push(row.fdError ? row.fdError : '');
            rowdata.push(row.orderTotal ? this.currenyFormatValue(row.orderTotal) : '');
            rowdata.push(row.source ? row.source : '');
            rowdata.push(row.shippingMethodDisplayName ? row.shippingMethodDisplayName : '');
            rowdata.push(row.paymentAmount ? this.currenyFormatValue(row.paymentAmount) : '');
            rowdata.push(row.orderCC ? (String.fromCharCode(39) + row.orderCC) : '');
            rowdata.push(row.deliveryMethodId ? this.getDeliveryPreference(row.deliveryMethodId) : '');
            rowdata.push(row.warehouseName ? row.warehouseName : '');
            rowdata.push(row.paymentError ? row.paymentError : '');
            rowdata.push(row.paymentProcessorTransactionNo ? (String.fromCharCode(39) + row.paymentProcessorTransactionNo) : '');
            finalrows.push(rowdata);
        }
        this._customerservice.ExcelDownload(columns, finalrows, 'Orders Report', '', false);


    }


    /**
     * Print functionality for report details printing
     */
    printReportDetails(title: string, columns: any, allOrdersReportLength: any) {
        let rowdataForPrint = new Array<any>();
        const finalrowsForPrint = new Array<any>();
        for (let i = 0; i < allOrdersReportLength; i++) {
            rowdataForPrint = [];
            const rowForPrint = this.allOrdersReport[i];
            rowdataForPrint.push(rowForPrint.itemNumbers ? rowForPrint.itemNumbers : '');
            rowdataForPrint.push(rowForPrint.revisionNumbers ? rowForPrint.revisionNumbers : '');
            rowdataForPrint.push(rowForPrint.webOrderId ? rowForPrint.webOrderId : '');
            rowdataForPrint.push(rowForPrint.orderNumber ? rowForPrint.orderNumber : '');
            rowdataForPrint.push(rowForPrint.paymentMode ? rowForPrint.paymentMode : '');
            rowdataForPrint.push(rowForPrint.paymentStatus ? rowForPrint.paymentStatus : '');
            rowdataForPrint.push(rowForPrint.cardType ? rowForPrint.cardType : '');
            rowdataForPrint.push(rowForPrint.memberLevelId ? this.getMemberLevel(rowForPrint.memberLevelId) : '');
            rowdataForPrint.push(rowForPrint.orderTypeId ? this.getOrderType(rowForPrint.orderTypeId) : '');
            rowdataForPrint.push(rowForPrint.orderCreatedDate ? this._datePipe.transform(rowForPrint.orderCreatedDate, DateConstants.DTFormat) : '');
            rowdataForPrint.push(rowForPrint.orderPostedDate ? this._datePipe.transform(rowForPrint.orderPostedDate, DateConstants.DTFormat) : '');
            rowdataForPrint.push(rowForPrint.paymentDate ? this._datePipe.transform(rowForPrint.paymentDate, DateConstants.DTFormat) : '');
            const fboId = rowForPrint.distributorId ? this.distributorFormatPipe.transform(rowForPrint.distributorId) : '';
            rowdataForPrint.push(fboId);
            rowdataForPrint.push(rowForPrint.memberTypeId ? this.getMemberType(rowForPrint.memberTypeId) : '');
            rowdataForPrint.push(rowForPrint.orderStatus ? rowForPrint.orderStatus : '');
            rowdataForPrint.push(rowForPrint.as400Ack ? rowForPrint.as400Ack : '');
            rowdataForPrint.push(rowForPrint.as400Error ? rowForPrint.as400Error : '');
            rowdataForPrint.push(rowForPrint.fulfillmentStatus ? rowForPrint.fulfillmentStatus : '');
            rowdataForPrint.push(rowForPrint.fulfillmentNumber ? rowForPrint.fulfillmentNumber : '');
            rowdataForPrint.push(rowForPrint.fdError ? rowForPrint.fdError : '');
            rowdataForPrint.push(rowForPrint.orderTotal ? this.currenyFormatValue(rowForPrint.orderTotal) : '');
            rowdataForPrint.push(rowForPrint.source ? rowForPrint.source : '');
            rowdataForPrint.push(rowForPrint.shippingMethodDisplayName ? rowForPrint.shippingMethodDisplayName : '');
            rowdataForPrint.push(rowForPrint.paymentAmount ? this.currenyFormatValue(rowForPrint.paymentAmount) : '');
            rowdataForPrint.push(rowForPrint.orderCC ? rowForPrint.orderCC : '');
            rowdataForPrint.push(rowForPrint.deliveryMethodId ? this.getDeliveryPreference(rowForPrint.deliveryMethodId) : '');
            rowdataForPrint.push(rowForPrint.warehouseName ? rowForPrint.warehouseName : '');
            rowdataForPrint.push(rowForPrint.paymentError ? rowForPrint.paymentError : '');
            rowdataForPrint.push(rowForPrint.paymentProcessorTransactionNo ? rowForPrint.paymentProcessorTransactionNo : '');
            finalrowsForPrint.push(rowdataForPrint);
        }
        this._customerservice.constructTableAndPrint(columns, finalrowsForPrint, title);
    }

}




// WEBPACK FOOTER //
// ./src/app/customerservice/components/reports/order-reports.component.ts